"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateDataAvailabilityTooltipText = void 0;
exports.getColumns = getColumns;
exports.getDefaultCustomFooter = void 0;
exports.getOptions = getOptions;
var _react = _interopRequireDefault(require("react"));
var _TableFooter = _interopRequireDefault(require("@material-ui/core/TableFooter"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _TablePagination = _interopRequireDefault(require("@material-ui/core/TablePagination"));
var _reactRouterDom = require("react-router-dom");
var _helpers = require("./helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
//  Generate MuiTable's columns.
function getColumns(tableConfig, classes, data, externalLinkIcon) {
  var linkto = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var linkClick = arguments.length > 5 ? arguments[5] : undefined;
  var DocumentDownloadComponent = arguments.length > 6 ? arguments[6] : undefined;
  var replaceEmptyValueWith = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
  var updatedTableWithLinks = (0, _helpers.manipulateLinks)(tableConfig.columns);
  return updatedTableWithLinks.slice(0, 12).map(function (column, index) {
    return {
      name: column.dataField,
      label: column.header,
      options: {
        display: typeof column.display !== 'undefined' ? column.display : true,
        filter: typeof column.filter !== 'undefined' ? column.filter : false,
        customBodyRender: function customBodyRender(value, tableMeta) {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: classes["tableCell".concat(index + 1)]
          }, value && !column.downloadDocument ? column.internalLink ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.HashRouter, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
            className: classes.link,
            to: "".concat(column.actualLink).concat(tableMeta.rowData[column.actualLinkId] ? tableMeta.rowData[column.actualLinkId] : '')
          }, value)) : column.externalLink ? /*#__PURE__*/_react.default.createElement("span", {
            className: classes.linkSpan
          }, /*#__PURE__*/_react.default.createElement("a", {
            href: "".concat(column.actualLink).concat(tableMeta.rowData[column.actualLinkId] ? tableMeta.rowData[column.actualLinkId] : ''),
            target: "_blank",
            rel: "noopener noreferrer",
            className: classes.link
          }, ' ', column.formatBytes ? (0, _helpers.formatBytes)(value) : value, ' '), externalLinkIcon ? /*#__PURE__*/_react.default.createElement("img", {
            src: externalLinkIcon.src,
            alt: externalLinkIcon.alt,
            className: classes.externalLinkIcon
          }) : '') : /*#__PURE__*/_react.default.createElement("div", {
            className: classes["tableCell".concat(index + 1)]
          }, ' ', column.dataFromRoot ? data[column.dataField] : column.formatBytes ? (0, _helpers.formatBytes)(value) : column.dataField === 'num_subjects' || column.dataField === 'numberOfCases' ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.HashRouter, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
            className: classes.link,
            to: function to(location) {
              return _objectSpread(_objectSpread({}, location), {}, {
                pathname: linkto
              });
            },
            onClick: function onClick() {
              return linkClick(tableMeta);
            }
          }, value)) : "".concat(column.formatBytes ? (0, _helpers.formatBytes)(value) : value), ' ') : replaceEmptyValueWith, column.downloadDocument && /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(DocumentDownloadComponent, {
            fileSize: tableMeta.rowData[updatedTableWithLinks.findIndex(function (tableRowData) {
              return tableRowData.dataField === column.documentDownloadProps.fileSizeColumn;
            })],
            fileLocation: tableMeta.rowData[updatedTableWithLinks.findIndex(function (tableRowData) {
              return tableRowData.dataField === column.documentDownloadProps.fileLocationColumn;
            })],
            fileFormat: tableMeta.rowData[updatedTableWithLinks.findIndex(function (tableRowData) {
              return tableRowData.dataField === column.documentDownloadProps.fileFormatColumn;
            })],
            caseId: tableMeta.rowData[updatedTableWithLinks.findIndex(function (tableRowData) {
              return tableRowData.dataField === column.documentDownloadProps.caseIdColumn;
            })],
            maxFileSize: column.documentDownloadProps.maxFileSize,
            toolTipTextUnauthenticated: column.documentDownloadProps.toolTipTextUnauthenticated,
            toolTipTextFileDownload: column.documentDownloadProps.toolTipTextFileDownload,
            toolTipTextFilePreview: column.documentDownloadProps.toolTipTextFilePreview,
            toolTipTextFileViewer: column.documentDownloadProps.toolTipTextFileViewer,
            iconUnauthenticated: column.documentDownloadProps.iconUnauthenticated,
            iconFileDownload: column.documentDownloadProps.iconFileDownload,
            iconFilePreview: column.documentDownloadProps.iconFilePreview,
            iconFileViewer: column.documentDownloadProps.iconFileViewer,
            requiredACLs: value
          })));
        }
      }
    };
  });
}
var getDefaultCustomFooter = function getDefaultCustomFooter(count, page, rowsPerPage, changeRowsPerPage, changePage, classes) {
  if (count >= 1) {
    return /*#__PURE__*/_react.default.createElement(_TableFooter.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(_TablePagination.default, {
      className: classes.root,
      count: count,
      page: page,
      rowsPerPage: rowsPerPage,
      onChangeRowsPerPage: function onChangeRowsPerPage(event) {
        return changeRowsPerPage(event.target.value);
      }
      // eslint-disable-next-line no-shadow
      ,

      onChangePage: function onChangePage(_, page) {
        return changePage(page);
      }
    })));
  }
  return '';
};
exports.getDefaultCustomFooter = getDefaultCustomFooter;
function getOptions(table, classes, _customFooter, onRowSelectionChange, _isRowSelectable) {
  return {
    selectableRows: typeof table.selectableRows !== 'undefined' ? table.selectableRows : false,
    responsive: typeof table.responsive !== 'undefined' ? table.responsive : false,
    search: typeof table.search !== 'undefined' ? table.search : false,
    filter: typeof table.filter !== 'undefined' ? table.filter : false,
    searchable: typeof table.searchable !== 'undefined' ? table.searchable : false,
    print: typeof table.print !== 'undefined' ? table.print : false,
    viewColumns: typeof table.viewColumns !== 'undefined' ? table.viewColumns : false,
    pagination: typeof table.pagination !== 'undefined' ? table.pagination : true,
    headerPagination: typeof table.headerPagination !== 'undefined' ? table.headerPagination : false,
    footerPagination: typeof table.footerPagination !== 'undefined' ? table.footerPagination : true,
    download: typeof table.download !== 'undefined' ? table.download : false,
    legendTooltip: typeof table.legendTooltip !== 'undefined' ? table.legendTooltip : false,
    origin: table.title,
    rowsPerPageOptions: table.rowsPerPageOptions ? table.rowsPerPageOptions : [10, 25, 50, 100],
    sortOrder: {
      name: table.defaultSortField,
      direction: table.defaultSortDirection
    },
    downloadOptions: {
      filename: table && table.downloadFileName ? table.downloadFileName : 'Bento_files_download.csv',
      filterOptions: {
        useDisplayedColumnsOnly: table.filterOptions && table.filterOptions && typeof table.filterOptions.useDisplayedColumnsOnly !== 'undefined' ? table.filterOptions.useDisplayedColumnsOnly : false
      }
    },
    customToolbarSelect: function customToolbarSelect() {
      return '';
    },
    customFooter: function customFooter(count, page, rowsPerPage, changeRowsPerPage, changePage) {
      return _customFooter ? _customFooter(count, page, rowsPerPage, changeRowsPerPage, changePage, classes) : getDefaultCustomFooter(count, page, rowsPerPage, changeRowsPerPage, changePage, classes);
    },
    isRowSelectable: function isRowSelectable(dataIndex) {
      return _isRowSelectable ? _isRowSelectable(dataIndex) : true;
    },
    onRowsSelect: function onRowsSelect(curr, allRowsSelected) {
      return onRowSelectionChange ? onRowSelectionChange(curr, allRowsSelected) : null;
    }
  };
}
var ICDC_DATA_AVAIL_ICONS = [{
  label: 'Case Files',
  icon: 'https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/icdc/images/svgs/CaseFiles_.svg'
}, {
  label: 'Study Files',
  icon: 'https://raw.githubusercontent.com/CBIIT/datacommons-assets/master/icdc/images/svgs/StudyFiles_.svg'
}, {
  label: 'Image Collections',
  icon: 'https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/icdc/images/svgs/StudyDataAvail-ImageCollection.svg'
}, {
  label: 'Publications',
  icon: 'https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/icdc/images/svgs/StudyDataAvail-Publications.svg'
}, {
  label: 'Additional CRDC Nodes',
  icon: 'https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/icdc/images/svgs/StudyDataAvail-CRDCnodes.svg'
}];
var generateDataAvailabilityTooltipText = function generateDataAvailabilityTooltipText() {
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'grid',
      paddingTop: '0em'
    }
  }, /*#__PURE__*/_react.default.createElement("h3", {
    style: {
      textAlign: 'center'
    }
  }, "Data Availability:"), ICDC_DATA_AVAIL_ICONS.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        gap: '2em',
        marginBottom: '0.5em'
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: item.icon,
      alt: "".concat(item.label, " icon"),
      style: {
        width: '3em'
      }
    }), ' ', item.label);
  }));
};
exports.generateDataAvailabilityTooltipText = generateDataAvailabilityTooltipText;